import { GENERIC_STRINGS } from 'consts/consts';

export const replyInput = {
	placeholder: GENERIC_STRINGS.PLACE_HOLDER_WRITE_A_REPLY,
};
export const ERROR_MESSAGE = {
	characterLimitExceeded: GENERIC_STRINGS.CHARACTER_LIMIT_EXCEEDED,
	htmlTagNotAllowed: GENERIC_STRINGS.HTML_TAG_NOT_ALLOWED,
};
